import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import { queryIsDelayDocument } from '@/api/notice/documentApi.js';
import { queryNewDocument } from '@/api/dashboard/newdocmentApi.js';
export default {
  data: function data() {
    var columns = [{
      title: '文件编号',
      dataIndex: 'fileId',
      ellipsis: true,
      align: 'center',
      resizable: true,
      width: 10
    }, {
      title: '缓急',
      dataIndex: 'urgency',
      ellipsis: true,
      align: 'center',
      resizable: true,
      width: 10
    }, {
      title: '密级',
      dataIndex: 'secretLevel',
      ellipsis: true,
      align: 'center',
      resizable: true,
      width: 10
    }, {
      title: '文件名称',
      dataIndex: 'fileName',
      ellipsis: true,
      align: 'center',
      width: 55
    }, {
      title: '公文模板',
      dataIndex: 'tempName',
      ellipsis: true,
      align: 'center',
      width: 55
    }, {
      title: '发文日期',
      dataIndex: 'docTime',
      ellipsis: true,
      align: 'center',
      width: 25
    }, {
      title: '阅读状态',
      dataIndex: 'status',
      align: 'center',
      width: 10,
      scopedSlots: {
        customRender: 'status'
      }
    }, {
      title: '操作',
      dataIndex: '',
      align: 'center',
      width: 10,
      scopedSlots: {
        customRender: 'action'
      }
    }];
    return {
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18
      },
      pagination: this.$hdk.page(),
      // pagination: {
      //     total: 0,
      //     defaultPageSize: 10,
      //     showTotal: total => `共 ${total} 条数据`,
      //     showSizeChanger: true,
      //     pageSizeOptions: ['10', '15', '20'],
      //     onShowSizeChange: (current, pageSize) => (this.pageSize = pageSize)
      // },
      expand: false,
      formState: {
        title: '',
        serialNumber: '',
        type: undefined,
        node: '',
        status: undefined,
        time: [],
        startDate: '',
        endDate: ''
      },
      text: '',
      columns: columns,
      list: [],
      loading: false
    };
  },
  created: function created() {
    this.searchQueryNoticeFillAdopt();
  },
  methods: {
    /**
     * 列表数据请求
     */
    searchQueryNoticeFillAdopt: function searchQueryNoticeFillAdopt(options) {
      var _this = this;
      var pagination = this.pagination,
        formState = this.formState,
        pager = _.assign({}, pagination, options);
      this.loading = true;
      if (this.formState.time.length > 0) {
        this.formState.startDate = this.formState.time[0];
        this.formState.endDate = this.formState.time[1];
      } else {
        this.formState.startDate = null;
        this.formState.endDate = null;
      }
      if (!pager.formState) {
        pager.formState = formState;
      }
      queryNewDocument(pager.current, pager.pageSize, pager.formState).then(function (res) {
        _this.list = res.data.data.rows;
        _.assign(pagination, {
          total: res.data.data.total,
          current: pager.current,
          pageSize: pager.pageSize
        });
        _.assign(formState, pager.formState);
      }).finally(function () {
        _this.loading = false;
      });
    },
    /**
     * 搜索按钮查询
     */
    search: function search() {
      this.pagination.current = 1;
      this.pagination.pageSize = 10;
      this.searchQueryNoticeFillAdopt();
    },
    toggle: function toggle() {
      this.expand = !this.expand;
    },
    change: function change(pagination) {
      this.searchQueryNoticeFillAdopt({
        current: pagination.current,
        pageSize: pagination.pageSize,
        formState: this.formState
      });
    },
    /**
     * 打开查阅情况
     */
    view: function view(row) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, req;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              row.id = row.docId;
              localStorage.removeItem('needData');
              localStorage.setItem('needData', JSON.stringify(row));
              _context.n = 1;
              return queryIsDelayDocument({
                docId: row.docId
              });
            case 1:
              res = _context.v;
              if (!(res.data.data === 1)) {
                _context.n = 2;
                break;
              }
              _this2.$message.error('此公文审核未通过，无法进行查看！');
              return _context.a(2);
            case 2:
              req = {
                id: row.docId
              };
              _this2.$router.push({
                path: '/docNotice/doc/docSendView',
                query: {
                  data: req,
                  backto: 'put',
                  look: 'editNewDocumentState'
                }
              });
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }))();
    }
  },
  mounted: function mounted() {}
};